import React, { Fragment, useEffect } from 'react'
import { Container, Row, Col} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import DatosGeneralesModal from './DatosGeneralesModal'
import TabsModal from './tabsModal'
import Mensajes from '../../mensajes'

const ModalPrincipal = ({ID, formik, setRutConductorFinal, setRutPropietarioFinal, setPaisImplicadoFinal,setShowToast, showToast}) => {
  const dispatch = useDispatch()
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const {respuestaImplicado  } = data_datos_implicado

  const handleCloseToast = () => {
    setShowToast(false);
  }
  return (
    <>
      
      <DatosGeneralesModal formik={formik} ID={ID} />
      <TabsModal
        formik={formik}
       
        setRutConductorFinal={setRutConductorFinal}
        setRutPropietarioFinal={setRutPropietarioFinal}
        setPaisImplicadoFinal={setPaisImplicadoFinal}
      />
      <Container>
        <Row>
        <Col>
              {respuestaImplicado && 
                <Mensajes
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    delay={5000}
                    responseData={respuestaImplicado?.respuestaImplicado}
                ></Mensajes>
              }
          </Col>
        </Row>
      </Container>
      {/* </Form> */}
    </>
  )
}

export default ModalPrincipal
